import React, { useState } from 'react';
import { Button, notification } from 'antd';
import ExportExcel from '../ExportExcel';
import styles from './ExcelButton.module.scss';
import { useSelector } from 'react-redux';
import { buildReportSummaryParams, fetchReportSummaryExport } from '../../../../../services/reportSummary';
import { saveBlob } from '../../../../../utils/saveBlob';

const dictionaryChartType = {
  'EDU_SERVICE_REPORT': 1,
  'EDU_PROVIDER_REPORT': 3,
};

const dictionaryTitle = {
  'EDU_SERVICE_REPORT': 'Отчет по внутреннему контролю за качеством оказания государственных услуг',
  'EDU_ACTIVITY_REPORT': 'Отчет о выполнении мероприятий по госуслугам',
  'EDU_PROVIDER_REPORT': 'Отчет по услугодателям',
};

// Отчет по мероприятиям: шаблона на фронте нет, файл собирает бек
const ActivityExportButton = ({ formValues, fileName }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      // reportType — служебное поле фронта, на бек его не отправляем
      const { reportType, ...selectors } = formValues;
      const response = await fetchReportSummaryExport(buildReportSummaryParams(selectors));
      saveBlob(response.data, `${fileName}.xlsx`);
    } catch (err) {
      notification.error({ message: 'Ошибка при экспорте в Excel' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleExport} loading={loading}>
      Экспорт в Excel
    </Button>
  );
};

export const ExcelButton = ({ reports }) => {
  const formValues = useSelector((state) => state.reportSummary.formSelectorsReportData);
  const fileName = dictionaryTitle[formValues.reportType];

  return (
    <div className={styles.container}>
      <h3 className={styles.subtitle}>
        {fileName}
      </h3>
      {formValues.reportType === 'EDU_ACTIVITY_REPORT' ? (
        <ActivityExportButton formValues={formValues} fileName={fileName} />
      ) : (
        <ExportExcel
          fileName={fileName}
          chartType={dictionaryChartType[formValues.reportType]}
          data={reports}
        />
      )}
    </div>
  );
};
